import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';

const API_URL = process.env.REACT_APP_API_URL;

export default function AdminGuestPosts() {
  const [posts, setPosts]     = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState('');
  const [search, setSearch]   = useState('');
  const { getIdToken }        = useAuth();

  useEffect(() => {
    axios.get(`${API_URL}/api/articles.json`)
      .then((res) => { setPosts(res.data.articles || []); setLoading(false); })
      .catch(() => { setError('Failed to load guest posts.'); setLoading(false); });
  }, []);

  async function togglePublish(post) {
    const token = getIdToken();
    try {
      await axios.put(
        `${API_URL}/api/articles/${post.id}.json`,
        { published: !post.published },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setPosts((prev) => prev.map((p) => p.id === post.id ? { ...p, published: !p.published } : p));
    } catch {
      setError('Failed to update post.');
    }
  }

  const filtered = posts.filter((p) =>
    !search || p.title?.toLowerCase().includes(search.toLowerCase()) ||
    p.authorName?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      <div style={s.topBar}>
        <h2 style={s.pageTitle}>All Guest Posts</h2>
        <input
          style={s.search}
          placeholder="Search by title or author..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {error && <div style={s.error}>{error}</div>}

      {loading ? (
        <div style={s.loading}>Loading...</div>
      ) : filtered.length === 0 ? (
        <div style={s.empty}>No guest posts found.</div>
      ) : (
        <div style={s.card}>
          <div style={s.tableHead}>
            <span>Title</span><span>Author</span><span>Status</span><span>Date</span><span>Action</span>
          </div>
          {filtered.map((p) => (
            <div key={p.id} style={s.tableRow}>
              <Link to={`/article/${p.id}`} style={s.title}>{p.title}</Link>
              <span style={s.cell}>{p.authorName || '—'}</span>
              <span style={{ ...s.badge, ...(p.published ? s.pub : s.draft) }}>
                {p.published ? 'Published' : 'Draft'}
              </span>
              <span style={s.date}>{fmtDate(p.createdAt)}</span>
              <button
                onClick={() => togglePublish(p)}
                style={p.published ? s.unpubBtn : s.pubBtn}
              >
                {p.published ? 'Unpublish' : 'Publish'}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function fmtDate(d) {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

const s = {
  topBar: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1.5rem', gap: '1rem' },
  pageTitle: { margin: 0, fontSize: '1.4rem', fontWeight: 700, color: '#1a1a2e' },
  search: { padding: '0.55rem 1rem', border: '1px solid #ddd', borderRadius: 6, fontSize: '0.875rem', outline: 'none', width: 280 },
  error: { background: '#fee', border: '1px solid #fcc', padding: '0.75rem 1rem', borderRadius: 6, marginBottom: '1rem', color: '#c00', fontSize: '0.9rem' },
  loading: { textAlign: 'center', padding: '3rem', color: '#888' },
  empty: { textAlign: 'center', padding: '3rem', color: '#888', background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' },
  card: { background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.06)', overflow: 'hidden' },
  tableHead: { display: 'grid', gridTemplateColumns: '2fr 1fr 120px 120px 100px', padding: '0.7rem 1.25rem', background: '#f8f8f8', fontSize: '0.72rem', fontWeight: 700, textTransform: 'uppercase', color: '#999', borderBottom: '1px solid #eee' },
  tableRow: { display: 'grid', gridTemplateColumns: '2fr 1fr 120px 120px 100px', padding: '0.9rem 1.25rem', borderBottom: '1px solid #f0f0f0', alignItems: 'center' },
  title: { fontWeight: 600, fontSize: '0.875rem', color: '#1a1a2e', textDecoration: 'none', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', paddingRight: '0.5rem' },
  cell: { fontSize: '0.82rem', color: '#555' },
  badge: { fontSize: '0.72rem', fontWeight: 700, padding: '0.2rem 0.55rem', borderRadius: 20, display: 'inline-block' },
  pub: { background: '#dcfce7', color: '#15803d' },
  draft: { background: '#f3f4f6', color: '#6b7280' },
  date: { fontSize: '0.8rem', color: '#888' },
  pubBtn: { padding: '0.3rem 0.7rem', background: '#dcfce7', color: '#15803d', border: 'none', borderRadius: 4, fontSize: '0.78rem', fontWeight: 600, cursor: 'pointer' },
  unpubBtn: { padding: '0.3rem 0.7rem', background: '#fee2e2', color: '#dc2626', border: 'none', borderRadius: 4, fontSize: '0.78rem', fontWeight: 600, cursor: 'pointer' },
};
